module.exports = __webpack_public_path__ + "static/media/logistics_payment.67a56396.svg";